import React from "react";
import { useLanguage } from "../LanguageContext";

const TitleAllProduct = () => {
  const { language } = useLanguage();
  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading">
          <span>All Products</span>
        </h2>

        {language === "en" ? (
          <>
            <p className="description">
              <strong> Explore Our Technology Product Portfolio</strong>
              <br />
              At Proscope, we go beyond product distribution—we deliver complete
              technology solutions that align with your business objectives. As
              a trusted system integrator, we offer a curated portfolio of
              <strong> enterprise hardware</strong>,
              <strong> business software</strong>, and
              <strong> specialized solutions</strong> from global and emerging
              vendors.
              
            <br />
            <br />
            </p>
 
            <p className="description">
              Whether you're upgrading your infrastructure, deploying secure
              platforms, or seeking niche technologies, our engineering and
              consulting teams are here to assist from selection to
              implementation. <br /> Discover the right tools to power your
              transformation.
            </p>
          </>
        ) : (
          <>
            <p className="description">
              ที่ Proscope เราไม่ได้เป็นเพียงผู้จัดจำหน่ายสินค้าไอที —
              แต่เราส่งมอบโซลูชันแบบครบวงจรที่สอดคล้องกับเป้าหมายของธุรกิจคุณในฐานะ
              System Integrator ที่เชื่อถือได้
              เราคัดสรรผลิตภัณฑ์จากผู้ผลิตระดับโลกและแบรนด์เทคโนโลยีรุ่นใหม่
              รวมถึงอุปกรณ์สำหรับองค์กร ซอฟต์แวร์ธุรกิจ และโซลูชันเฉพาะทาง
              <br /> 
              <br /> 
              </p>
              <p className="description">
              ไม่ว่าคุณจะกำลังอัปเกรดระบบโครงสร้างพื้นฐาน วางระบบความปลอดภัย
              หรือมองหาเทคโนโลยีเฉพาะทาง
              ทีมวิศวกรและที่ปรึกษาของเราพร้อมช่วยเหลือคุณตั้งแต่การเลือกผลิตภัณฑ์
              ไปจนถึงการติดตั้งและใช้งานจริง <br />
              ค้นหาเครื่องมือที่ใช่ เพื่อขับเคลื่อนการเปลี่ยนผ่านสู่อนาคตของคุณ
            </p>
          </>
        )}

        <div className="horizontal-text-container">
          <p>Products</p>
          <p>/</p>
          <p>All Products</p>
        </div>
      </div>
    </div>
  );
};

export default TitleAllProduct;
